import { render } from "./FolderContextMenuComponent.vue?vue&type=template&id=759f68b4&scoped=true&ts=true"
import script from "./FolderContextMenuComponent.vue?vue&type=script&lang=ts"
export * from "./FolderContextMenuComponent.vue?vue&type=script&lang=ts"

import "./FolderContextMenuComponent.vue?vue&type=style&index=0&id=759f68b4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-759f68b4"]])

export default __exports__